import { apiClient } from "api";
import { TDocumentType, TDocumentTypePicklist } from "./models/types";

export const getAllDocumentTypesList = async (accountId: string) => {
  const response = await apiClient.get<TDocumentTypePicklist[]>(
    `documentTypes/list/${accountId}`
  );
  return response.data;
};

export const getAllDocumentTypes = async (accountId: string) => {
  const response = await apiClient.get<TDocumentType[]>(`documentTypes/${accountId}`);
  return response.data;
};

export const addOrUpdateDocumentType = async (
  accountId: string,
  documentType: TDocumentType,
  isNew: boolean
): Promise<TDocumentType> => {
  const response = await apiClient({
    method: isNew ? "post" : "put",
    url: `documentTypes`,
    data: { ...documentType, accountId }
  });
  return response.data;
};
